// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_il-7";
export var emphasizeQuantity = "_il-3";
export var flatBottomCorners = "_il-5";
export var productImage = "_il-0";
export var quantityContainer = "_il-2";
export var quantityHeader = "_il-6";
export var tooltip = "_il-1";
export var wrapAndEllipsesOverflow = "_il-4";